// Copyright (c) 2025 Goffy. All Rights Reserved.

import { create } from 'zustand';

type DebugState = {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
};

export const useDebugState = create<DebugState>((set) => ({
  enabled: false,
  setEnabled: (enabled) => set({ enabled }),
}));
